// Material Dashboard 2 React - v2.2.0

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import Swal from "sweetalert2";

// Layout & Component Imports
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import MyModal from "components/Modal"; // Pastikan path sesuai
import { CloudUpload } from "@mui/icons-material";
// Data
import accountTableData from "layouts/account/data/accountTableData";
import BASE_URL from "config/Base_URL";
// Library
import { useState } from "react";
import axios from "axios";

function Produk() {
  const token = sessionStorage.getItem("token");
  const { columns, rows, modalEdit, modalDetail, modalDelete } = accountTableData();
  const [modalShow, setModalShow] = useState(false);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Users
                </MDTypography>
              </MDBox>

              {/* <MDBox
                mx={2}
                mt={3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="transparent"
                borderRadius="lg"
              >
                <MDButton variant="gradient" color="dark" onClick={() => setModalShow(true)}>
                  <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                  &nbsp;Tambah Produk
                </MDButton>
              </MDBox> */}

              <MDBox pt={3} px={2}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
                {/* modal Edit Produk*/}
                {modalEdit}

                {/* modal Detail Produk */}
                {modalDetail}

                {/* modal Delete Produk */}
                {modalDelete}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Produk;
